import $ from 'jquery'

SOPHIA.modalMessage = function (message, type, focusElement, hideCloseButton) {
  var timer,
      closeBtn,
      enableEscapeButton;

  hideCloseButton = hideCloseButton || false;

  if (hideCloseButton == true) {
    enableEscapeButton = false;
    closeBtn = 'false';
  } else {
    enableEscapeButton = 'close';
    closeBtn = '<button data-sophypop-close class="sophypop-close-small" aria-label="Close"></button>'
  }

  if (type != 'error') {
    timer = setTimeout(function() {
      SOPHIA.closeOverlayBox();
    }, 4000);
  }

  SOPHIA.overlayBox('<div class="flexible-popup modal-message">'+message+'</div>', {
    btnTpl: {
      smallBtn: closeBtn
    },
    clickSlide: enableEscapeButton,
    keyboard : enableEscapeButton,
    afterClose: function() {
      if (type != 'error') {
        clearTimeout(timer);
      }
    },
    afterLoad: function() {
      if (hideCloseButton) {
        $('a.close-popup').remove();
      }
    }
  }, focusElement);
};
